import React from "react";

import { useTranslation } from "react-i18next";

import Block from "../block/Block";
import VariableList from "../variable_list/VariableList";

import type { JSX } from "react";

interface SmartlistVariablesBlockProps {
  value: Record<string, string> | null;
  onChange: (variables: Record<string, string>) => void;
}

export default function SmartlistVariablesBlock({
  value,
  onChange,
}: SmartlistVariablesBlockProps): JSX.Element {
  const { t } = useTranslation("editor-utils");

  return (
    <Block title={t("variables")}>
      <div className="editor-form-section">
        <div className="editor-form-input">
          <VariableList onChange={onChange} variables={value} />
        </div>
      </div>
    </Block>
  );
}
